import React from 'react'

const PillMeter = ({ value, onChange }) => {
  const colors = ['#22c55e', '#10d144', '#facc15', '#f97316', '#ef4444']
  return (
    <div className="flex items-center min-w-[230px] max-w-[270px] rounded-full overflow-hidden border border-gray-300 shadow-sm">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          className="flex-1 h-9 text-xs sm:text-sm font-semibold text-white"
          style={{
            backgroundColor: colors[n - 1],
            boxShadow: value === n ? 'inset 0 0 0 3px #0b5bff' : 'none',
            fontSize: value === n ? '1rem' : '0.9rem',
          }}
        >
          {n}
        </button>
      ))}
    </div>
  )
}

export default PillMeter
